import { useTranslation } from 'react-i18next'

import { Outlet } from 'react-router-dom'

import { Bell, Globe, Shield, User } from 'lucide-react'

import { paths } from '@/config/paths'

import DashboardContent from '../../../layouts/dashboard/DashboardContent'
import SidebarNav from '../components/sidebar-nav'

export default function ProfileSettingsLayout() {
  const { t } = useTranslation(['dashboard', 'common'])
  return (
    <DashboardContent
      title={t('dashboard:profileSettings.title', 'Profile Settings')}
      desc={t('dashboard:profileSettings.description', 'Manage your profile settings like name, email, password, etc.')}
    >
      <div className='flex h-full min-h-screen w-full max-w-4xl flex-col gap-6 lg:flex-row'>
        {/* Sidebar */}
        <aside className='lg:top-0 lg:w-4/12 lg:shrink-0'>
          <SidebarNav items={sidebarNavItems} />
        </aside>

        {/* Main content area */}
        <main className='flex-1 overflow-auto'>
          <div className='mx-auto w-full max-w-4xl'>
            <Outlet />
          </div>
        </main>
      </div>
    </DashboardContent>
  )
}

const sidebarNavItems = [
  {
    href: paths.dashboard.profile.root.getHref(),
    title: 'General',
    icon: <User className='h-5 w-5' />,
  },
  {
    href: paths.dashboard.profile.security.getHref(),
    title: 'Security',
    icon: <Shield className='h-5 w-5' />,
  },
  {
    href: paths.dashboard.profile.localization.getHref(),
    title: 'Localization',
    icon: <Globe className='h-5 w-5' />,
  },
  {
    href: paths.dashboard.profile.notifications.getHref(),
    title: 'Notifications',
    icon: <Bell className='h-5 w-5' />,
  },
]
